function InfoBox({ title = "", message = "" }) {
    return (
      <>
        {title && message && (
          <div className="info-box">
            <h3>{title}</h3>
            <span>{message}</span>
          </div>
        )}
      </>
    );
  }
  
  export default InfoBox;